import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ReportLayoutDefinition } from '../models/report-definition';

@Component({
   selector: 'app-report-layout-tabs',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './report-layout-tabs.component.html',
   styleUrls: ['./report-layout-tabs.component.scss']
})
export class ReportLayoutTabsComponent {
   @Input() layouts: ReportLayoutDefinition[] = [];
   @Input() activeLayoutId: string | null = null;
   @Input() noticeLayoutIds: ReadonlySet<string> = new Set<string>();
   @Input() noticeText = '';

   @Output() layoutSelected = new EventEmitter<string>();

   activeNoticeLayoutId: string | null = null;

   hasNotice(layoutId: string): boolean {
      return this.noticeLayoutIds.has(layoutId);
   }

   toggleNotice(layoutId: string, event: MouseEvent): void {
      event.preventDefault();
      event.stopPropagation();

      this.activeNoticeLayoutId =
         this.activeNoticeLayoutId === layoutId ? null : layoutId;
   }

   isNoticeVisible(layoutId: string): boolean {
      return this.activeNoticeLayoutId === layoutId;
   }

   selectLayout(layoutId: string): void {
      this.activeNoticeLayoutId = null;

      if (layoutId === this.activeLayoutId) {
         return;
      }

      this.layoutSelected.emit(layoutId);
   }
}
